webpackJsonp([35783957827783],{

/***/ 34:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(17);

/***/ }),

/***/ 176:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/avatar.1152bc7c.jpg";

/***/ }),

/***/ 314:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _icon = __webpack_require__(21);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	__webpack_require__(34);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(16);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _avatar = __webpack_require__(176);
	
	var _avatar2 = _interopRequireDefault(_avatar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IndexPage = function IndexPage(_ref) {
	  var data = _ref.data;
	
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      'My name is Dhruv Kumar Jha, I\'m a Full Stack Architect, Working on Interesting Products & Services.'
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'page--index flex' },
	      _react2.default.createElement(
	        'div',
	        { className: 'avatar flex--one' },
	        _react2.default.createElement('img', { src: _avatar2.default, alt: 'Dhruv Kumar Jha' })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'flex--two' },
	        _react2.default.createElement(
	          'p',
	          null,
	          'Here I share my experience in the technologies I work with.'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'I write tutorials and articles on ',
	          _react2.default.createElement(
	            'strong',
	            null,
	            'Javascript'
	          ),
	          ', ',
	          _react2.default.createElement(
	            'strong',
	            null,
	            'React JS'
	          ),
	          ', ',
	          _react2.default.createElement(
	            'strong',
	            null,
	            'Node JS'
	          ),
	          ', ',
	          _react2.default.createElement(
	            'strong',
	            null,
	            'AWS'
	          ),
	          ', ',
	          _react2.default.createElement(
	            'strong',
	            null,
	            'GraphQL'
	          ),
	          ' ',
	          _react2.default.createElement(
	            'strong',
	            null,
	            'Algorithms'
	          ),
	          ', ',
	          _react2.default.createElement(
	            'strong',
	            null,
	            'Python'
	          ),
	          ', ',
	          _react2.default.createElement(
	            'strong',
	            null,
	            'Machine Learning'
	          ),
	          ' and related technologies.'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'social--links' },
	          _react2.default.createElement(
	            'a',
	            { href: 'https://github.com/dhruv-kumar-jha', target: '_blank' },
	            _react2.default.createElement(_icon2.default, { type: 'github' })
	          ),
	          _react2.default.createElement(
	            'a',
	            { href: 'https://twitter.com/dhruv_kumar_jha', target: '_blank' },
	            _react2.default.createElement(_icon2.default, { type: 'twitter' })
	          ),
	          _react2.default.createElement(
	            'a',
	            { href: 'https://www.linkedin.com/in/dhruvkumarjha', target: '_blank' },
	            _react2.default.createElement(_icon2.default, { type: 'linkedin' })
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = IndexPage;
	
	/*
	<h4 style={{ marginBottom: 0, color: '#999' }}>Hi and Welcome to my Website.</h4>
	<h1>I'm a Full Stack Architect, Working on Products, Services & APIs that makes things simple and interesting.</h1>
	<h1>My name is Dhruv Kumar Jha, I'm a Full Stack Architect, Working on Interesting Products, Services & APIs.</h1>

	*/

	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-424b3d78e466047d3d72.js